import React from 'react'
import { Box, Typography, Chip, IconButton } from '@mui/material'
import { Info, CheckCircle, Star } from 'lucide-react'
import { FlightSegment } from '@/src/types/flight'
import { getFlightLogoUrl } from '@/src/utils/generalUtils/airlineImage'
import { useTranslations } from 'next-intl'

interface FlightSegmentHeaderProps {
    segment: FlightSegment
    onTimePercentage?: number
    rating?: number
    reviewCount?: number
    airlineNames?: Record<string, string>
}

const FlightSegmentHeader: React.FC<FlightSegmentHeaderProps> = ({
    segment,
    onTimePercentage = 90,
    rating = 4.6,
    reviewCount = 3124,
    airlineNames
}) => {
    const [flightName, flightCode] = segment.flightNumber.split('-')
    const operatingAirlineName = airlineNames?.[segment.oa]
    const t = useTranslations('common')
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, gap: 3 }}>
            {/* Left side - Airline info */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1 }}>
                <Box
                    component="img"
                    src={getFlightLogoUrl(flightName)}
                    alt={segment.flightName}
                    sx={{
                        height: 28,
                        width: 28,
                        objectFit: 'contain',
                        bgcolor: 'white',
                        border: '1px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1
                    }}
                />
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                }}
                >
                    <Box sx={{
                        display: 'flex',
                        gap: 1 
                    }}>
                        <Typography variant="body2" fontWeight="bold" fontSize="14px" color="text.primary">
                            {segment.flightName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" fontWeight="medium">
                            |
                        </Typography>
                        <Typography variant="body2" color="text.primary" fontSize="14px" fontWeight="normal">
                            {flightName} {flightCode}
                        </Typography>
                    </Box>
                    <Box>
                        {operatingAirlineName && (
                            <Typography variant="body2" color="text.primary" fontSize="11px" fontWeight="normal">
                                {t('operatingAirlineName', { operatingAirlineName })}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Box>

            {/* Right side - Status badges */}
            {/* <Box sx={{ display: 'flex', gap: 1 }}>
                <Chip
                    onClick={e => e.stopPropagation()}
                    clickable={false}
                    icon={<CheckCircle size={12} />}
                    label={`${onTimePercentage}% on-time`}
                    size="small"
                    sx={{
                        backgroundColor: '#f0fdf4',
                        color: '#16a34a',
                        border: '1px solid #dcfce7',
                        fontSize: '10px',
                        height: '24px',
                        fontWeight: 'semibold',
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        '& .MuiChip-icon': {
                            fontSize: 12,
                            mr: 0.5
                        },
                        '&:hover': {
                        }
                    }}
                />
                <Chip
                    onClick={e => e.stopPropagation()}
                    clickable={false}
                    icon={<Star size={12} />}
                    label={`${rating}%(${reviewCount})`}
                    size="small"
                    sx={{
                        backgroundColor: '#fffbeb',
                        color: '#d97706',
                        border: '1px solid #fef3c7',
                        fontSize: '10px',
                        height: '24px',
                        fontWeight: 'semibold',
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        '& .MuiChip-icon': {
                            fontSize: 12,
                            mr: 0.5
                        },
                        '&:hover': {
                        }
                    }}
                />
            </Box> */}
        </Box>
    )
}

export default FlightSegmentHeader
